import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { money } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function AgentDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [month, setMonth] = useState(() => new Date().toISOString().slice(0, 7));
  useEffect(() => {
    api.get(`/agents/${id}/performance`, { params: { month } }).then(r => setData(r.data));
  }, [id, month]);
  if (!data) return <div>Loading…</div>;
  const a = data.agent;
  const kpi = (label, value, tone="") => (
    <div className="bg-white rounded-xl border border-slate-200 p-5">
      <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
      <div className={`kpi-value text-3xl mt-2 ${tone}`}>{value}</div>
    </div>
  );
  return (
    <div className="space-y-6" data-testid="agent-detail-page">
      <Link to="/agents" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#003DA5]"><ArrowLeft className="w-4 h-4" /> Back</Link>
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div>
          <h1 className="text-3xl font-heading font-black">{a.name}</h1>
          <p className="text-slate-600">{a.email} • Territories: {(a.assigned_states || []).join(", ") || "—"}</p>
        </div>
        <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="h-11 px-3 border border-slate-300 rounded-lg" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {kpi("Monthly Sales", money(data.monthly_sales), "text-[#003DA5]")}
        {kpi("Sales Target", money(data.sales_target))}
        {kpi("Target Achieved", `${data.target_achievement_pct}%`)}
        {kpi("Growth", `${data.growth_pct}%`)}
        {kpi("Active Customers", data.active_customers)}
        {kpi("Inactive Customers", data.inactive_customers)}
        {kpi("No-Sale Customers", data.no_sale_customers)}
        {kpi("New Customers", data.new_customers)}
        {kpi("Visits Completed", data.visits_completed)}
        {kpi("Stores Not Visited", data.stores_not_visited)}
        {kpi("Follow-ups Completed", data.followups_completed)}
        {kpi("Follow-ups Overdue", data.followups_overdue)}
        {kpi("Opportunity Pipeline", money(data.estimated_opportunity_pipeline))}
      </div>
    </div>
  );
}
